<template>
    <div class="popup modal fade">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
              <div class="list-content">
                <h4>個資告知條款</h4>
               <p>
                 本公司為能快速、正確的回覆您的問題，須蒐集您的姓名(無需全名，簡稱、暱稱亦可)、電子信箱、聯絡電話、客訴事件之時、地及經過等相關個人資料。請您提供正確的電話或電子信箱，以便本公司回覆。您所留下的各項資料，本公司將於處理該客訴事件或反應事項之必要範圍內提供予本公司、本公司旗下之關係企業、加盟店或與您詢問事項有關之處理人員、廠商進行查證、聯繫等特定目的使用。除非事先說明、或依照相關法律規定，否則本公司不會將您個人資料提供給第三人、或移作其他目的使用。且您得隨時來電主張個人資料保護法第三條規定之權利，以維護個資安全。您有權拒絕提供個人資料，但如果您提供的資料有誤或不足時，本公司可能無法提供您完整的服務。本公司已履行上開告知義務，如您已留下聯繫方式等相關個人資料，視為同意本蒐集、處理及利用個人資料告知事項。
               </p>
              </div>
            <div>
              <div class="popup-btn">
                <a  @click="closePopup"><b>返回</b></a>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>
<script>
  export default {
    props:{
      text:{
        type: String,
        required:true
      }
    },
    data(){
      return{

      }
    },
    mounted() {
      console.log("user",this.users)
    },
    methods: {
      closePopup(e){
        e.stopPropagation();
        this.$emit("closeChanged",false);
      }
    },
  }
</script>
<style scoped lang="scss">
  .list-content{
    background: #fff;
    max-height: 613px;
    max-width: 587px;
    border: 7px solid rgba(151,151,151,0.05);
    border-radius: 30px;
    box-shadow: 0 10px 20px 0 rgba(0,0,0,0.05);
    padding: 30px 20px;
    ul{
      padding: 0;
      margin: 0;
      list-style: none;
    }
    li{
      min-height: 60px;
      &:nth-child(even){
        background: rgb(251, 251, 251);
      }
      span{
        display: inline-block;
        font-size: 18px;
        letter-spacing: 0.9px;
        line-height: 30px;
        vertical-align: middle;
        padding: 15px 30px;
      }
      .job{
        width: 30%;
        color: #2A1C15;
        font-weight: 500;
        border-right: solid 1px #f5f4f4;
      }
      .name{
        width: calc(70% - 5px);
        color: #261A16;
        text-align: justify;
      }
    }
  }
  .popup{
    width: 110%;
    height: 100%;
    display:block;
    background: rgba(0,0,0,0.7);
    .modal-content{
      background: none;
      border: 0;
    }
    .popup-btn{
      height: 60px;
      line-height: 60px;
      width: 250px;
      border-radius: 35px;
      background-color: #F5AC2D;
      margin: auto;
      margin-top:52px;
      cursor: pointer;
      a{
        width: 100%;
        display: inline-block;
        color: #262D35;
        font-size: 20px;
        font-weight: 500;
        text-align: center;
      }
    }
  }
  @media (max-width:1080px){
    .popup{
      padding: 30px 20px;
      width: 100%;
      background: rgba(255,255,255,0.7);
      .modal-content{
        img{
          width: 100%;
          height: 100%;

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/default/clausePopup.vue